import React from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { useAddSinglewireTokenModal } from './useAddSinglewireTokenModal';
import './addSinglewireToken.scss';

const AddSingleWireTokenModal = () => {
  const {
    handleAddButtonClick,
    showModel,
    handleClose,
    handleShow,
    setToken,
    token,
    singlewireTokenResponse,
  } = useAddSinglewireTokenModal();

  return (
    <>
      <span className='singlewire-btn'>
        <Button onClick={handleShow}>
          <span>
            {Boolean(singlewireTokenResponse.userId)
              ? 'Update Token'
              : 'Add Token'}
          </span>
        </Button>
      </span>

      <Modal
        show={showModel}
        onHide={handleClose}
        className='modal-container create-new-org-admin'
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {Boolean(singlewireTokenResponse.userId)
              ? 'Update Token'
              : 'Add Token'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='add-group-container'>
            <div className='create-new-org-admin'>
              <Form.Group
                className='mb-3'
                controlId='exampleForm.ControlInput1'
              >
                <Form.Label>Singlewire Software Token</Form.Label>
                <Form.Control
                  type='text'
                  placeholder={
                    Boolean(singlewireTokenResponse.userId)
                      ? '************************'
                      : 'Add your token here....'
                  }
                  onChange={(e) => {
                    setToken(e.target.value);
                  }}
                  required
                />
              </Form.Group>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className='btn-cancel' onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className='btn-style'
            disabled={!(token.length > 0)}
            type='submit'
            onClick={handleAddButtonClick}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddSingleWireTokenModal;
